import React from "react";
import list from "javascriptstuff-db/linters";

import Page from "../../components/common/Page";
import ListPageContainer from "../../components/list/ListPageContainer";
import StyledTextBlock from "../../components/common/StyledTextBlock";
import addNotes from "../../logic/addNotes";

const extendedList = addNotes(list, {
  "prettier/prettier": `Using prettier really increases the readability of your code by automatically keeping your code wrapped to a reasonable line-length. Great when combined with another linter like ESLint to catch potential errors.`
});

export default () => (
  <Page>
    <ListPageContainer list={extendedList}>
      <StyledTextBlock>
        <p>
          Linters find potential errors and/or formatting inconsistencies in
          your code.
        </p>
        <p>
          Some will <a href="#tag:autofix">automatically fix</a> your code for
          you. Most are configurable, but others are{` `}
          <a href="#tag:opinionated">opinionated</a> (meaning you must subscribe
          to the given rules without changing anything).
        </p>
      </StyledTextBlock>
    </ListPageContainer>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/list/linters.js